
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle, MessagesStatus } from '../../../models/messages';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import Swal from "sweetalert2";
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-listado-acceso',
  templateUrl: './listado-acceso.component.html',
  styleUrls: ['./listado-acceso.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle, MessagesStatus]
})
export class ListadoAccesoComponent implements OnInit {
  @Output() cerrarListaAcceso: EventEmitter<boolean>;
  @Output() evento = new EventEmitter<number>();
  @Output() sistema = new EventEmitter<string>();
  abrirPopUpRol: boolean = false;
  form: FormGroup;
  user: any;
  ipAddress: any;
  repAccesos: any = [];
  repSistemas: any = [];
  repSistemasFact: any = [];
  repRoles: any = [];
  repPermisos: any = [];
  rol: any;
  loading: boolean = false;
  isLoading: boolean = true;
  save: boolean = false;
  dataUser: any;
  nombre: string = ''
  id_sistema: any;
  id_acceso: any;
  id_rol: any;
  Rol: any;
  dataSource1: any = [];
  dataSource: any = [];
  datosEnviarAct: any;
  id_rol_path: any;

  constructor(private securityService: SecurityService, private router: Router, private msgTitulos: MessagesTitles, private msgStatus: MessagesStatus) {
    this.cerrarListaAcceso = new EventEmitter();

    try {
      this.dataUser = this.securityService.dataUser;

      this.nombre = this.dataUser.Nombre;
    } catch (error) {
      this.router.navigate(['/usuarios/listado']);
    }

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.form = new FormGroup({
      id_user: new FormControl(this.dataUser.id_user),
      id_sistemas: new FormControl('', [Validators.required]),
      id_roles: new FormControl('', [Validators.required]),
      Ruta: new FormControl('-', []),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    });
  }

  displayedColumns1 = ['Nombre', 'Rol', 'Ruta', 'Editar'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.ObtenerListaSistemas();
    this.ObtenerListaRoles();
    this.ObtenerListaAccesos();
    this.ObtenerListaPermisos();
  }

  filterItemsOfId() {
    return this.repRoles.filter(x => x.id_sistemas == this.id_sistema);
  }

  filterItemsOfIdPath() {
    return this.repPermisos.filter(x => x.id_roles == this.id_rol_path && x.Ruta_dsc != null && x.Ruta_dsc != "");
  }

  changeClient(value) {
    this.id_rol = value;
  }

  FiltrarRol(element: any) {
    this.id_sistema = element.id_sistemas;
    this.id_acceso = element.id_accesos;
    this.Rol = element.id_roles_dsc;
    this.filterItemsOfId();
  }

  FiltrarPath(element: any) {
    this.id_rol_path = element.id_roles;
    this.filterItemsOfIdPath();
  }

  CerrarPopUp() {
    this.cerrarListaAcceso.emit();
  }

  Atras() {
    this.cerrarListaAcceso.emit();
  }

  ObtenerListaAccesos() {
    this.loading = true;
    this.securityService.ObtenerListaAccesos()
      .subscribe(resp => {
        this.repAccesos = resp
        this.dataSource = this.filterAccesosOfId();
        this.dataSource1 = new MatTableDataSource(this.dataSource);
        this.isLoading = false;
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ACCESO NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  filterAccesosOfId() {
    return this.repAccesos.filter(x => x.id_user == this.dataUser.id_user);
  }

  ObtenerListaSistemas() {
    this.loading = true;
    this.securityService.ObtenerListaSistemas()
      .subscribe(resp => {
        this.repSistemas = resp
        /*if (this.user.id_empresa != 1) {
          this.repSistemas = this.repSistemas.filter(sis => sis.Sistema == 'Intranet');
        }*/
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA SISTEMAS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  ObtenerListaRoles() {
    this.loading = true;
    this.securityService.ObtenerListaRoles(this.user.id_empresa)
      .subscribe(resp => {
        this.repRoles = resp;

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  ObtenerListaPermisos() {
    this.loading = true;
    this.securityService.ObtenerListaPermisos(this.user.id_empresa)
      .subscribe(resp => {
        this.repPermisos = resp
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (!(err.error instanceof ErrorEvent)) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA PERMISOS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  GuardarAcceso() {

    console.log('--xxxx->', this.form.getRawValue());
    if (this.form.invalid) {
      Swal.fire({
        title: '¡Incomplete form!',
        text: 'Verificar los campos resaltados de color rojo',
        type: 'warning',
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }

    let a = this.dataSource.filter(object => object.id_sistemas == this.form.value.id_sistemas);
    if (a.length > 0) {
      Swal.fire({
        title: '¡¡Advertencia!',
        text: 'Usuario ya tiene un Rol para este sistema',
        type: 'warning',
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }
    Swal.fire({
      title: '¡Espere!',
      text: 'Estamos guardando la información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    if (this.form.controls["id_sistemas"].value == 2) {
      this.form.get('Host').setValue('EXTRANET');
    }
    console.log('--->', this.form.getRawValue());
    this.securityService.RegistrarAcceso(this.form.getRawValue())
      .subscribe(resp => {
        Swal.fire({
          title: "Éxito",
          text: "Acceso guardado correctamente.",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res => {

          if (res.value == true) {
            this.ngOnInit();
          }

        });
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "ACCESO NO GUARDADO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      });
  }

  EditarRol(elemento: any) {
    this.securityService.dataRolAcceso = elemento;
    this.abrirPopUpRol = true;
  }

  CerrarPopUpRol() {
    this.abrirPopUpRol = false;
  }

  Refresh() {
    this.ngOnInit();
  }
}











